import { React, useState } from 'react'
import LoginPage from './LoginPage'
import 'styles/css/login.css'

const LoginForm = ({ setLoginActiveView }) => {
  const [rotated, setRotated] = useState(false)

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className={`card ${rotated ? 'rotated' : ''} mt-3`}>
            <div className="card-face card-front">
              <div className="card-body">
                <LoginPage setLoginActiveView={setLoginActiveView} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default LoginForm
